import React from 'react';
import { IconProps } from 'common/interfaces';

export const FAQIcon = ({ width = 52, height = 42 }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox='0 0 52 42' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.15845 16.9202C0.610378 21.1715 1.52875 25.1709 3.46922 28.5186L1.43988 36.1027C1.2325 36.8285 1.9139 37.4951 2.63972 37.3026L10.1942 35.2732C10.1942 35.2732 13.3181 36.8427 15.3572 37.3026C15.8715 37.4185 16.394 37.5127 16.9238 37.584C18.4949 37.7954 20.1306 37.8052 21.8074 37.584C30.1914 36.473 36.8424 29.5851 37.6422 21.1566C38.491 12.0881 32.7604 4.21505 24.669 1.77744C22.4514 1.10935 20.0564 0.849559 17.571 1.08536C9.15731 1.87043 2.25459 8.53618 1.15845 16.9202Z'
        fill='#E6F7FF'
      />
      <path
        d='M15.3555 37.3026C13.3163 36.8427 10.1924 35.2732 10.1924 35.2732L2.63793 37.3026C1.91211 37.4951 1.2307 36.8285 1.43808 36.1027L3.46742 28.5186C1.52695 25.1709 0.608583 21.1715 1.15665 16.9202C2.2528 8.53618 9.15551 1.87043 17.5692 1.08536C19.6408 0.888815 21.6496 1.03659 23.5453 1.47812'
        stroke='#8FAFBF'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M50.8433 19.9807C51.3914 24.232 50.4731 28.2315 48.5326 31.5791L50.5619 39.1633C50.7693 39.8891 50.0879 40.5557 49.3621 40.3631L41.8076 38.3338C41.8076 38.3338 38.6837 39.9033 36.6446 40.3631C34.6054 40.8229 32.4368 40.9404 30.1944 40.6445C21.8104 39.5336 15.1594 32.6457 14.3596 24.2172C13.2782 12.6632 22.8769 3.04976 34.4308 4.1459C42.8445 4.93098 49.7472 11.5967 50.8433 19.9807Z'
        fill='white'
      />
      <path
        d='M41.8076 38.3338L49.3621 40.3631C50.0879 40.5557 50.7693 39.8891 50.5619 39.1633L48.5326 31.5791C50.4731 28.2315 51.3914 24.232 50.8433 19.9807C49.7472 11.5967 42.8445 4.93098 34.4308 4.1459C22.8769 3.04976 13.2782 12.6632 14.3596 24.2172C15.1594 32.6456 21.8104 39.5336 30.1944 40.6445C32.4367 40.9404 34.6054 40.8229 36.6446 40.3631'
        stroke='#8FAFBF'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M39.2554 20.3506C38.1096 20.3506 37.1721 21.2881 37.1721 22.4339C37.1721 23.5797 38.1096 24.5172 39.2554 24.5172C40.4013 24.5172 41.3387 23.5797 41.3387 22.4339C41.3387 21.2881 40.4013 20.3506 39.2554 20.3506Z'
        fill='#8FAFBF'
      />
      <path
        d='M26.0212 20.3506C24.8754 20.3506 23.9379 21.2881 23.9379 22.4339C23.9379 23.5797 24.8754 24.5172 26.0212 24.5172C27.167 24.5172 28.1045 23.5797 28.1045 22.4339C28.1045 21.2881 27.167 20.3506 26.0212 20.3506Z'
        fill='#8FAFBF'
      />
      <path
        d='M32.6373 20.3506C31.4915 20.3506 30.554 21.2881 30.554 22.4339C30.554 23.5797 31.4915 24.5172 32.6373 24.5172C33.7831 24.5172 34.7206 23.5797 34.7206 22.4339C34.7206 21.2881 33.7831 20.3506 32.6373 20.3506Z'
        fill='#8FAFBF'
      />
    </svg>
  );
};
